export const DEFAULT_EVENTS_PER_PAGE = 20;
